import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ClientPartnerService } from '../../_services/client-partner.service';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-partners-page',
    templateUrl: './partners-page.component.html',
    styleUrls: ['./partners-page.component.css'],
    standalone: false
})
export class PartnersPageComponent implements OnInit {
    partners = [];
    loading = true;
    apiUrl = environment.apiUrl;

    constructor(
        private titleService: Title,
        private clientPartnerService: ClientPartnerService,
        private translateService: TranslateService
    ) { }

    ngOnInit() {
        this.translateService.get('common.partners_and_customers').subscribe(value => {
            this.titleService.setTitle(value);
        });
        this.loadPartners();
        window.scrollTo(0, 0);
    }

    loadPartners() {
        this.clientPartnerService.loadAll().subscribe({
            next: (response: any) => {
                this.partners = (response.data || response || []).map((partner: any) => ({
                    id: partner.id,
                    name: partner.clientPartnerName,
                    image_path: partner.logoPath ? `${this.apiUrl}/${partner.logoPath}` : ''
                }));
                this.loading = false;
            },
            error: () => {
                this.partners = [];
                this.loading = false;
            }
        });
    }
}
